export function isEmail(email) {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)
}



// WEBPACK FOOTER //
// ./src/Utils/Validators/email.js